/**
 * displayName — Single source of truth for how a Métier member's name is
 * rendered anywhere in the UI.
 *
 * Priority: display_name → name → first + last → first → "Métier Member".
 * Guarantees we never leak database IDs, emails, "undefined", "null",
 * "Test User", or any hard-coded placeholder to end-users.
 *
 * @param {Object|null|undefined} u  – any user-shaped object
 * @returns {string}  – always a non-empty, human-readable name
 */
const PLACEHOLDER_TOKENS = new Set([
  "undefined", "null", "test user", "anonymous", "member",
  "unknown", "unknown member", "user",
]);

function _clean(v) {
  if (!v || typeof v !== "string") return "";
  const s = v.trim();
  if (!s) return "";
  if (PLACEHOLDER_TOKENS.has(s.toLowerCase())) return "";
  return s;
}

export function displayName(u) {
  if (!u) return "Métier Member";
  const dn = _clean(u.display_name);
  if (dn) return dn;
  const n = _clean(u.name);
  if (n) return n;
  const first = _clean(u.first_name || u.firstName);
  const last  = _clean(u.last_name  || u.lastName);
  if (first && last) return `${first} ${last}`;
  if (first) return first;
  return "Métier Member";
}

/** First-name only (used for composer greetings). Safe for empty names. */
export function firstName(u) {
  const dn = displayName(u);
  return dn.split(/\s+/)[0] || "Métier Member";
}

export default displayName;
